

// url of api 
export const AppUrl = "https://api.ananthjeevan.in/public/api/"


export const GET_STATE = "states"
export const GET_CITY = "cities"


// DR registration end endPoints
export const DRREGISTRATION = "doctor/registration"
